export default function BottomTabs({ active, onChange }) {
  const tabs = [
    { id: 'map', icon: '🗺️', label: 'Map', desc: 'District View' },
    { id: 'races', icon: '🎯', label: 'Races', desc: 'All Districts' },
    { id: 'run', icon: '🏃', label: 'Run', desc: 'Get Involved' }
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900 via-slate-800 to-slate-800/95 border-t border-slate-600/50 shadow-2xl z-50 safe-bottom backdrop-blur-lg"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="flex justify-around max-w-lg mx-auto">
        {tabs.map(tab => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              aria-controls={`${tab.id}-panel`}
              onClick={() => onChange(tab.id)}
              className={`
                relative flex flex-col items-center py-2.5 px-5 min-w-[80px] min-h-[56px]
                transition-all duration-300 ease-out
                ${isActive
                  ? 'text-white'
                  : 'text-slate-400 hover:text-slate-200'
                }
              `}
            >
              {/* Active indicator bar */}
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-gradient-to-r from-blue-400 to-cyan-400 rounded-full shadow-lg shadow-blue-500/50" />
              )}

              {/* Icon with glow when active */}
              <div className={`
                relative text-2xl transition-transform duration-300
                ${isActive ? 'scale-110' : 'group-hover:scale-105'}
              `}>
                {isActive && (
                  <div className="absolute inset-0 bg-blue-400/30 blur-lg rounded-full" />
                )}
                <span className="relative" role="img" aria-label={`${tab.label} icon`}>
                  {tab.icon}
                </span>
              </div>

              {/* Label */}
              <span className={`
                text-xs mt-1 font-semibold transition-colors
                ${isActive ? 'text-blue-300' : ''}
              `}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
